import { LoadableLazy } from '@confluence/loadable';

export const LazySpaceHoverPageCard = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceHoverPageCard" */ './SpaceHoverPageCard.tsx'))
			.SpaceHoverPageCard,
});
